
export default {
  name: 'AtomPinIconText',
  props: {
    pinInfo: {
      required: false,
      type: Object,
      default: function () {
        return {
          pinTitle: '',
          pinDescription: ''
        }
      }
    }
  }
}
